export class PaymentDataRequest {
    paymentMethodKey: string;
    cbu: string;
    creditCardNumber: string;
    creditCardTypeKey: string;
    collectorKey: string;
    sendsCuponsByKey: string;
    paymentInstrumentId: string;
    isExistingPayment: boolean;
}
